import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Tab, Tabs } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AppContext from '../../Services/AppContext';
import PersistantData from '../../Services/PersistantData';
import ComposeTab from './components/ComposeTab';
import ManageTab from './components/ManageTab';
import InboxTab from './components/InboxTab';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(1)
	},
	tabs: {
		marginBottom: theme.spacing(1)
	}
}));

export default function Announcement() {
	const classes = useStyles();
	const singleton = PersistantData.getInstance();
	const location = useLocation();
	const [gState] = useContext(AppContext);
	var { translation: language, client } = gState;
	if (typeof (language) === 'undefined') {
		language = singleton.getlang();
	}

	const tabFromQuery = () => {
		const raw = new URLSearchParams(location.search).get('tab');
		const parsed = parseInt(raw);
		return parsed === 1 ? 1 : 0;
	};

	const [tabPosition, setTabPosition] = useState(tabFromQuery());
	const [editData, setEditData] = useState(null);

	const isComposer = client === 'easymdemo';

	useEffect(() => {
		setTabPosition(tabFromQuery());
		setEditData(null);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location.key, location.search]);

	if (!isComposer) {
		return (
			<div className={classes.root}>
				<InboxTab language={language} client={client} />
			</div>
		);
	}

	return (
		<div className={classes.root}>
			<Tabs
				className={classes.tabs}
				indicatorColor="primary"
				textColor="inherit"
				value={tabPosition}
				onChange={(e, v) => {
					setTabPosition(v);
					if (v !== 0) {
						setEditData(null);
					}
				}}>
				<Tab label={language.announcement_compose} />
				<Tab label={language.announcement_manage} />
			</Tabs>
			{tabPosition === 0 && (
				<ComposeTab
					language={language}
					client={client}
					editData={editData}
					onDone={() => {
						setEditData(null);
						setTabPosition(1);
					}}
				/>
			)}
			{tabPosition === 1 && (
				<ManageTab
					language={language}
					client={client}
					onEdit={(row) => {
						setEditData(row);
						setTabPosition(0);
					}}
				/>
			)}
		</div>
	);
}
